import React from 'react';
import PropTypes from 'prop-types';

export default function FileIcon({ size, color, ...rest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 44 58" fill={color} {...rest}>
      <path d="M42.717201,12.874584 L30.338192,0.514983 C29.953353,0.193119 29.504373,0 29.055394,0 L3.399417,0 C1.539359,0 0,1.54495 0,3.411765 L0,54.588235 C0,56.45505 1.539359,58 3.399417,58 L40.600583,58 C42.460641,58 44,56.45505 44,54.588235 L44,16.09323 C44,14.870144 43.55102,13.775805 42.717201,12.874584 Z M40.664723,14.483907 L30.402332,14.483907 C29.953353,14.483907 29.568513,14.097669 29.568513,13.647059 L29.568513,3.347392 L40.664723,14.483907 Z M40.600583,55.682575 L3.399417,55.682575 C2.758017,55.682575 2.244898,55.167592 2.244898,54.523862 L2.244898,3.411765 C2.244898,2.768036 2.758017,2.253052 3.399417,2.253052 L27.387755,2.253052 L27.387755,13.711432 C27.387755,15.385128 28.734694,16.736959 30.402332,16.736959 L41.755102,16.736959 L41.755102,54.588235 C41.755102,55.167592 41.241983,55.682575 40.600583,55.682575 Z" />
    </svg>
  );
}

FileIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

FileIcon.defaultProps = {
  size: 20,
  color: '#000',
};
